import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/bottlesSimple/form'
import { api, actionCreators } from 'store/modules/bottlesSimple'

const metadata = {
  icon: 'glass',
  page: 'bottlesSimple',
  dialogSize: dialogSizes.XL
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
